// extracted by mini-css-extract-plugin
export default {"subComponent":"DocumentGroupTable__subComponent___3z3vc"};